import { useQuery } from "@tanstack/react-query";
import { fetchAllPaginated } from "@/lib/supabase-paginate";
import { fetchRange, type AttemptStatsRow } from "@/lib/lead-stats-calc";

/**
 * Ringeaktivitet per bruker og dag (view lead_attempt_stats_v, security_invoker). Henter fra
 * tidligste av periodens start og ukens mandag til seneste av periodens slutt og i dag, så
 * «i dag», «denne uken» og «valgt periode» regnes fra samme rader. Bundet av datoene.
 */
export function useLeadStats(period: { fromDate: string; toDate: string }, options: { enabled?: boolean; now?: Date } = {}) {
  const range = fetchRange(options.now ?? new Date(), period);
  return useQuery({
    queryKey: ["lead-stats", period.fromDate, period.toDate, range.from, range.to],
    queryFn: async (): Promise<AttemptStatsRow[]> => {
      const data = await fetchAllPaginated<AttemptStatsRow>(
        "lead_attempt_stats_v",
        "user_id, day, calls, answered, meetings_booked, meetings_held",
        (q) => q.gte("day", range.from).lte("day", range.to),
        ["day", "user_id"],
      );
      return data.map((r) => ({
        user_id: r.user_id,
        day: r.day,
        calls: Number(r.calls),
        answered: Number(r.answered),
        meetings_booked: Number(r.meetings_booked),
        meetings_held: Number(r.meetings_held),
      }));
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  });
}
